import { render } from "./AddJobVacancy.vue?vue&type=template&id=96709e38&scoped=true"
import script from "./AddJobVacancy.vue?vue&type=script&lang=js"
export * from "./AddJobVacancy.vue?vue&type=script&lang=js"

import "./vacancy.scss?vue&type=style&index=0&id=96709e38&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96709e38"]])

export default __exports__